import { PayrollResource, UserResource, BatchResource, ProjectResource, AssignmentResource } from '@sigmacloud/sigma-client/dist/resources'

export default class CustomPayrollResource extends PayrollResource {
  // There are more related fields, but these are the only ones needed at the moment.
  static related = {
    payroll_coordinator: UserResource,
    batch: BatchResource,
    project: ProjectResource,
    assignment: AssignmentResource
  }
}
